import {Dispatch, SetStateAction} from 'react';
import CustomAccordion from '../../../../../components/CustomAccordion';

interface IProps {
  openAccordion: number | null;
  setOpenAccordion: (index: number | null) => void;
}

const FAQAccordions = ({openAccordion, setOpenAccordion}: IProps) => {
  return (
    <div className="space-y-1 leading-5">
      <CustomAccordion
        accordionTitle="آیا اعتبار مزرعه نقدی هست؟"
        index={0}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          خیر، اعتبار مزرعه نقدی نیست و فقط برای خرید از فروشگاه‌های طرف قرارداد
          قابل استفاده است. حتی در صورت لغو خرید یا مرجوعی، امکان دریافت وجه نقد
          وجود ندارد.
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="خدمات تسهیلاتی مزرعه شامل چه مواردی هست؟"
        index={1}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <div className="text-sm text-gray-600">
          <p>
            <span className="ml-1 font-bold">اعتبار مزرعه:</span>
            تا سقف 100 میلیون تومان اعتبار دریافت می‌کنید و مبلغ خرید را پس از
            برداشت محصول پرداخت می‌کنید.
          </p>

          <p>
            <span className="ml-1 font-bold">وام بانکی:</span>
            تا سقف 300 میلیون تومان وام بانکی برای خرید دریافت می‌کنید و اقساط
            را ماهانه به بانک بازپرداخت می‌کنید.
          </p>
        </div>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="چه شرایط و مدارکی برای دریافت تسهیلات لازم است؟"
        index={2}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          <p>
            افراد بین ۱۸ تا ۶۵ سال، در صورت داشتن شرایط زیر، می‌توانند از خدمات
            تسهیلاتی مزرعه استفاده کنند:
          </p>

          <p>
            <span className="ml-1 font-bold">اعتبار مزرعه:</span>
            داشتن چک صیادی بنفش به نام خود، کسب امتیاز کافی در اعتبارسنجی مزرعه،
            نداشتن چک برگشتی یا قسط معوق، و چک ضمانت صیادی شخص ثالث.
          </p>
          <p>
            <span className="ml-1 font-bold">وام بانکی:</span> اعتبارسنجی مناسب
            بانکی و نداشتن چک برگشتی یا قسط معوق، اعتبارسنجی مناسب مزرعه، چک
            ضمانت صیادی شخص ثالث.
          </p>
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="دریافت تسهیلات مزرعه چه مراحلی دارد؟"
        index={3}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          <p>می‌توانید، به دو روش زیر تسهیلات را دریافت کنید:</p>

          <p>
            <span className="ml-1 font-bold">دریافت آنلاین اعتبار:</span>
            این فرایند کاملاً غیرحضوری است و از طریق سامانه مزرعه انجام می‌شود.
            مراحل دریافت شامل ثبت‌نام، اعتبارسنجی، بارگذاری مدارک، چک، امضای
            قرارداد و دریافت اعتبار است. کل فرایند حداکثر یک هفته زمان می‌برد.
          </p>
          <p>
            <span className="ml-1 font-bold">دریافت حضوری اعتبار:</span>
            برای دریافت سریع‌تر اعتبار، کافی است با مدارک لازم به یکی از
            فروشگاه‌های طرف قرارداد مراجعه کنید، مدارک را به فروشنده ارائه دهید
            و اعتبار خود را دریافت کنید. این فرایند معمولاً 15 تا 20 دقیقه زمان
            می‌برد و بلافاصله می‌توانید خرید کنید.
          </p>
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="آیا می‌توانم با چک فرد دیگری تسهیلات بگیرم؟"
        index={4}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          بله، برای دریافت وام از بانک، چک صیادی ضامن معتبر دریافت می‌شود. اما
          برای دریافت اعتبار، چک باید حتماً به نام خودتان باشد و امکان استفاده
          از چک دیگران وجود ندارد. چک‌های صیادی صادرشده از همه بانک‌ها پذیرفته
          می‌شوند.
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="چطور اعتبار مزرعه بگیرم؟"
        index={5}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          برای گرفتن اعتبار مزرعه کافیه وارد حساب کاربری‌ات در فروشگاه مزرعه
          بشی، به بخش «اعتبارهای من» بری و اطلاعات لازم برای درخواست اعتبار
          مزرعه رو تکمیل کنی. در کمتر از یک هفته کاری (یک ساعت/حضوری) اعتبارت رو
          تا سقف 100 میلیون تومان، بسته به رتبه اعتباری خودت، دریافت کن.
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="هزینه‌های دریافت تسهیلات و خرید با آن شامل چه مواردی می‌شود؟"
        index={6}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          <p>هزینه‌های دریافت اعتبار و خرید کالا شامل سه بخش است:</p>

          <ul className="flex flex-col gap-2">
            <li>
              • هزینه اعتبارسنجی و امضای دیجیتال: برای دریافت اعتبار، نیاز به
              اعتبارسنجی بانکی و اعتبارسنجی مزرعه دارید که رتبه اعتباری و
              خوش‌حسابی شما را بررسی می‌کند. با ساخت امضای دیجیتال هم، امکان
              امضای قرارداد برای شما فراهم میشه.
            </li>
            <li>
              • سود بانکی: تأمین‌کننده اعتبار، تسهیلات را با نرخ سود مشخصی ارائه
              می‌دهد. این نرخ توسط تأمین‌کننده تعیین می‌شود و سامانه مزرعه در
              تعیین یا دریافت آن نقشی ندارد.
            </li>
            <li>
              • تفاوت قیمت نقدی و اقساطی: قیمت نقدی و اقساطی کالاها متفاوت است.
              متناسب با نوع کالا و مدت زمان و شرایط تسهیلاتی دریافتی، تفاوت قیمت
              کالای نقد و اقساط مشخص می‌شود.
            </li>
          </ul>
        </p>
      </CustomAccordion>

      <CustomAccordion
        accordionTitle="چگونه باید اقساطم را پرداخت کنم؟"
        index={7}
        openAccordion={openAccordion}
        setOpenAccordion={setOpenAccordion}
      >
        <p className="text-sm text-gray-600">
          بسته به اینکه خرید شما با وام یا اعتبار مزرعه بوده، بازپرداخت اقساط هم
          مشخص می‌شود. در اعتبار مزرعه بعد از برداشت محصول برای پرداخت اقساط،
          ابتدا وارد حساب کاربری خود در مزرعه می‌شوید و سپس به قسمت «قسط‌های من»
          مراجعه کنید تا لیست اقساط فعال خود را مشاهده و پرداخت کنید. همچنین،
          سامانه مزرعه چند روز پیش از سررسید هر قسط و در روز موعد، از طریق پیامک
          زمان پرداخت را به شما یادآوری می‌کند. بازپرداخت اقساط در مدل خرید با
          وام توسط بانک عامل به شما اطلاع رسانی می‌شود و بازپرداخت اقساط هم در
          اپلیکیشن بانک امکانپذیرست
        </p>
      </CustomAccordion>
    </div>
  );
};

export default FAQAccordions;
